import { A4uVariable as IconComponent } from '@adobe/react-spectrum-workflow/dist/Variable.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Variable(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}